import {
  COMMENT_ERR,
  COMMENT_REQ,
  GET_BLOGS_ERROR,
  GET_BLOGS_REQ,
  GET_BLOGS_SUCCESS,
  GET_BLOG_SUCCESS,
  GET_CATEGORIES,
  GET_COMMENT_REPLY,
  GET_COMMENT_SUCCESS,
  GET_TRASH_SUCCESS,
  GET_USER,
  GET_USERS,
  LOGOUT_USER,
  REPLY_ERR,
  REPLY_REQ,
  SET_SUCCESS,
  USER_FAILURE,
  USER_PROFILE,
  USER_REQ,
} from "./Action";

let token =
  localStorage.getItem("jwtoken") || localStorage.getItem("refreshToken");
let auth = localStorage.getItem("isAuth") || false;
let user = JSON.parse(localStorage.getItem("User")) || {};

const initState = {
  isAuth: auth,
  user: user,
  token: token ? token : "",
  isError: false,
  isLoading: false,
  commentError: false,
  commentLoading: false,
  replyError: false,
  replyLoading: false,
  blogs: [],
  blogCount: 0,
  trash: [],
  trashCount: 0,
  users: [],
  comments: [],
  blog: [],
  replies: [],
  categories: [],
  profile: [],
};

export const reducer = (state = initState, { type, payload }) => {
  switch (type) {
    case USER_REQ:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case GET_USER:
      localStorage.setItem("User", JSON.stringify(payload));
      localStorage.setItem("isAuth", true);
      return {
        ...state,
        isAuth: true,
        user: payload,
        isLoading: false,
        isError: false,
        token: localStorage.getItem("jwtoken"),
      };
    case USER_FAILURE:
      localStorage.removeItem("User");
      localStorage.removeItem("isAuth");
      localStorage.removeItem("jwtoken");
      localStorage.removeItem("refreshtoken");

      return {
        ...state,
        isAuth: false,
        isLoading: false,
        user: {},
        isError: true,
      };
    case GET_BLOGS_REQ:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case GET_BLOGS_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    case GET_BLOGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        blogs: payload.filter((el) => el.softDelete === false),
        blogCount: payload.filter((el) => el.softDelete === false).length,
      };
    case GET_BLOG_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        blog: payload,
      };
    case GET_TRASH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        trash: payload.filter(
          (el) => el.user.email === state.user.user.email && el.softDelete
        ),
        trashCount: payload.filter(
          (el) => el.user.email === state.user.user.email && el.softDelete
        ).length,
      };
    case COMMENT_REQ:
      return {
        ...state,
        commentLoading: true,
        commentError: false,
      };
    case GET_COMMENT_SUCCESS:
      return {
        ...state,
        commentLoading: false,
        commentError: false,
        comments: payload,
      };
    case COMMENT_ERR:
      return {
        ...state,
        commentLoading: false,
        commentError: true,
      };
    case GET_CATEGORIES:
      return {
        ...state,
        categories: payload,
      };
    case REPLY_REQ:
      return {
        ...state,
        replyLoading: true,
        replyError: false,
      };
    case GET_COMMENT_REPLY:
      return {
        ...state,
        replyLoading: false,
        replyError: false,
        replies: payload,
      };
    case REPLY_ERR:
      return {
        ...state,
        replyLoading: false,
        replyError: true,
      };
    case GET_USERS:
      return {
        ...state,
        isError: false,
        users: payload,
      };
    case SET_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case USER_PROFILE:
      return {
        ...state,
        isLoading: false,
        isError: false,
        profile: payload,
      };
    case LOGOUT_USER:
      localStorage.removeItem("User");
      localStorage.removeItem("isAuth");
      localStorage.removeItem("jwtoken");
      localStorage.removeItem("refreshtoken");

      return {
        ...state,
        isAuth: false,
        isError: false,
        user: {},
      };
    default:
      return state;
  }
};
